import React from 'react'
import {Card, Drawer, Form, Icon, notification, Button, Tooltip, Input, Row, Col} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import _ from 'lodash'
import {connect} from 'react-redux'
import TextArea from 'antd/lib/input/TextArea'
import Request, {API_URL} from '../../request'
import moment from 'moment'
import Moment from "moment";

@Form.create()

class AddHolidayForm extends React.Component {
    state = {
        visible: true,
        disableBTN: false
    }

    onClose = () => {
        this.setState({
            visible: false
        })
        let $this = this
        setTimeout(() => {
            $this.props.onClose()
        }, 400)
    }

    handleSubmit = e => {
        const {dispatch, form} = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
          if (!err) {
            let values = _.clone(valData)
            let x = null
            if (this.state.holidayId) {
              values._id = this.state.holidayId
              x = await Request.updateGovtHolidays(values)
            } else {
              x = await Request.addGovtHolidays(values)
            }
    
            if (!x.error) {
              this.setState({
                id: '',
                activeTab: '0',
              })
              notification.success({
                message: this.state.holidayId
                  ? `Holiday Updated Successfully`
                  : 'Holiday Added successfully'
              })
              this.onClose();        
            } else {
              notification.error({
                message: 'Error Saving',
                description: x.msg
              })
            }
          }
        })
    }

    async componentDidMount() {
        const { currentEvent, form } = this.props;
        if(currentEvent) {
            setTimeout(function() {
                form.setFieldsValue({holidayDate: Moment(currentEvent.holidayDate)});  
                form.setFieldsValue({holidayName: currentEvent.holidayName});  
                form.setFieldsValue({holidayType: currentEvent.holidayType});  
                form.setFieldsValue({holidayId: currentEvent.holidayId});  
            }, 1000); 
        }         
    }

    render() {
        const { holidayDate } = this.props;
        const {
          form: {getFieldDecorator, setFieldsValue}
        } = this.props;

        const { disableBTN } = this.state;
        
        const inputTypes = {
            fields: [
                {
                    label: 'Holiday Title', 
                    key: 'holidayName', 
                    required: true
                },
                {
                    label: 'Holiday Date',
                    key: 'holidayDate',
                    required: true,
                    type: 'date',
                    customProps: {
                        disabledDate: d => !d || d.isBefore(moment().add(-1, 'day'))
                    }
                },
                {
                    label: 'Holiday Type',
                    key: 'holidayType',
                    required: true,
                    type: 'select',
                    disabled: false,
                    allowClear: true,
                    options: ['Paid', 'UnPaid'],
                    onChange: holidayType => {
                        setFieldsValue({holidayType: holidayType && holidayType.toString()})
                    }
                }
            ]
        };
        return (
            <Drawer
                title={
                    <div>
                        {'Add Holiday'} {' '}
                        {
                            disableBTN == false ? 
                                <a onClick={this.onClose} style={{float: 'right', color: 'black'}}>
                                    <Icon type={'close'}/>
                                </a>
                            :null
                        }                        
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                        <GetAllFormFields
                            apiurl={API_URL}
                            inputSchema={inputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                        <Button
                            type=""
                            htmlType="submit"
                            style={{
                                marginBottom: 10,
                                marginLeft: '33%',
                                backgroundColor: 'green',
                                color: 'white'
                            }}
                            disabled={disableBTN}
                            loading={this.props.loading}>
                            SAVE
                        </Button>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}
  
const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddHolidayForm)